import React from 'react';

const VALUES = [
  {
    title: 'Smart Homes',
    desc: 'Connected homes with intelligent energy monitoring and control.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" />
      </svg>
    ),
  },
  {
    title: 'Grid Efficiency',
    desc: 'Better visibility and management of electricity consumption.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" />
      </svg>
    ),
  },
  {
    title: 'Real-Time Insights',
    desc: 'Access energy data when and where it matters.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M3 17l5-5 4 4 8-9" /><path d="M14 7h6v6" />
      </svg>
    ),
  },
  {
    title: 'Greater Reliability',
    desc: 'Smart-metering infrastructure built for real-world conditions.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" />
      </svg>
    ),
  },
  {
    title: 'A Sustainable Tomorrow',
    desc: 'Technology that supports more efficient energy use and smarter communities.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
        <path d="M12 22c-5-2-8-6-8-11a8 8 0 0 1 16 0c0 5-3 9-8 11z" />
        <path d="M12 8v7" />
      </svg>
    ),
  },
];

const WhyGridxSection = () => (
  <section className="gh-section gh-why">
    <div className="gh-section__inner">
      <span className="eyebrow">Why GRIDx</span>
      <h2 className="gh-section__title">Five reasons utilities and homes choose GRIDx.</h2>

      <div className="gh-why__grid">
        {VALUES.map((v) => (
          <div key={v.title} className="gh-why__card">
            <div className="gh-why__icon">{v.icon}</div>
            <h3 className="gh-why__title">{v.title}</h3>
            <p className="gh-why__desc">{v.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyGridxSection;
